// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"437":"e2a5d0f9","885":"73bee43a"}[chunkId] + ".chunk.css";
};